export function byGradeValue({ asc = true } = {}) {
  return ({ gradeValue: a }, { gradeValue: b }) => {
    return asc ? b - a : a - b
  }
}

export default {
  byGradeValue
}
